import React, { useEffect, useState } from 'react';
import { TableCell, TableRow } from '@mui/material';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import BoxGrid from '@/main/components/shared/boxGrid/boxGrid';
import { getTranslateByKey } from '@/main/services/utils';
import * as S from './styles';
import { directAssignCriteriaApi } from '@/main/api';
import { DirectAssignCriteriaResponse } from '@/main/models/response/directAssignCriteriaResponse';
import DirectAssignCriteriaModal from '../directAssignCriteriaModal/directAssignCriteriaModal';
import ResultNotFoundComponent from '../resultNotFound/resultNotFoundComponent';
import LoadingComponent from '../loading/loadingComponent';

interface Props {
  guidBodyshop?: string | null;
  guidInsurer?: string | null;
  deleteDirectAssignCriteria: string[];
  setDeleteDirectAssignCriteria: React.Dispatch<React.SetStateAction<string[]>>;
}

function DirectAssignCriteriaInfo({
  guidBodyshop = null,
  guidInsurer = null,
  deleteDirectAssignCriteria,
  setDeleteDirectAssignCriteria
}: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [dataGrid, setDataGrid] = useState<DirectAssignCriteriaResponse[]>([]);

  const rowHeadersPurchaseCriteria = [
    getTranslateByKey('information.make'),
    getTranslateByKey('information.ageStart'),
    getTranslateByKey('information.ageEnd'),
    getTranslateByKey('information.claimType'),
    getTranslateByKey('information.partTypes'),
    <div style={{ textAlign: 'center' }}>
      {getTranslateByKey('information.actions')}
    </div>
  ];

  async function fetchData() {
    setIsLoading(true);
    directAssignCriteriaApi
      .searchGrid({
        guidBodyshop: guidBodyshop ?? undefined,
        guidInsurer: guidInsurer ?? undefined
      })
      .then(response => {
        const {
          data: { result }
        } = response;

        if (result) {
          setDataGrid(result);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  function handleDelete(item: DirectAssignCriteriaResponse) {
    setDeleteDirectAssignCriteria(prev => [...prev, ...item.guids]);
  }

  useEffect(() => {
    setDataGrid([]);
    fetchData();
  }, [guidBodyshop, guidInsurer]);

  return (
    <>
      <S.Container>
        <S.ContainerTitle>
          <S.HeaderText>
            {getTranslateByKey('information.directAssignCriteria')}
          </S.HeaderText>
          <SecondaryButton
            style={{
              padding: '.2rem .8rem',
              marginTop: '.6rem'
            }}
            onClick={() => setOpen(true)}
            id="id-button-add-directAssignCriteria">
            {getTranslateByKey('information.add')}
          </SecondaryButton>
        </S.ContainerTitle>

        {isLoading ? (
          <LoadingComponent />
        ) : dataGrid.length > 0 ? (
          <BoxGrid rowHeaders={rowHeadersPurchaseCriteria}>
            {dataGrid.map((item, index) => {
              const isMarkedToDelete = item.guids.some(g =>
                deleteDirectAssignCriteria.includes(g)
              );

              if (isMarkedToDelete) return null;

              return (
                <TableRow key={index}>
                  <TableCell width="20%">
                    {item.vehicleManufacturerName}
                  </TableCell>
                  <TableCell width="10%">{item.yearStart}</TableCell>
                  <TableCell width="10%">{item.yearEnd}</TableCell>
                  <TableCell width="25%">{item.claimTypes}</TableCell>
                  <TableCell width="25%">{item.partTypes}</TableCell>
                  <TableCell width="10%" align="center">
                    <S.IconClose onClick={() => handleDelete(item)} />
                  </TableCell>
                </TableRow>
              );
            })}
          </BoxGrid>
        ) : (
          <ResultNotFoundComponent />
        )}
      </S.Container>

      <DirectAssignCriteriaModal
        dataDirectAssignCriteriaGrid={dataGrid}
        open={open}
        setDirectAssignCriteriaGrid={setDataGrid}
        setOpen={setOpen}
        guidInsurer={guidInsurer}
        guidBodyShop={guidBodyshop}
      />
    </>
  );
}

export default DirectAssignCriteriaInfo;
